import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for PopularShiftsReflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  openedit () {
  } 
}
